export default __webpack_public_path__ + "static/designcontract-665896aba2f616769d8a6298c02ddc14.png";